// Fertig-Signale fuer das Startbild «Netzplan» (24.09.2026).
//
// Das Startbild liegt ueber der Anwendung, die darunter von der ersten Zeile an laedt.
// `App.js` nimmt es erst weg, wenn die Seite darunter meldet, dass sie steht - und
// fruehestens, wenn der Ablauf einmal ganz durch ist. Wer was meldet:
//
//   "projekte"   : ProjectContext, sobald die Projektliste da ist. Sie haengt am Rahmen
//                  (Auswahl oben links) und wird auf JEDER Route geladen - deshalb ist sie
//                  das Signal fuer alle Routen ausser der Startseite.
//   "uebersicht" : Startseite, sobald das Dashboard geladen ist (auch leer).
//   "fehler"     : wenn die Projektliste oder das Dashboard NICHT laedt. Hebt die
//                  Mindestdauer auf, damit die Fehlermeldung nicht verdeckt bleibt.
//
// Bewusst ein winziges Modul und kein Context: das Startbild wird ausserhalb des Routers
// gerendert, ein gemeinsamer Provider muesste ueber die ganze Anwendung gelegt werden, nur
// um ein paar Merker nach oben zu geben.

export type SplashSignal = "projekte" | "uebersicht" | "fehler";

const gemeldet = new Set<SplashSignal>();
const listeners = new Set<() => void>();

/** „Das steht" - von der Stelle aufzurufen, die hinter dem Startbild laedt. Mehrfach harmlos. */
export const signalSplashReady = (signal: SplashSignal): void => {
    if (gemeldet.has(signal)) return;
    gemeldet.add(signal);
    listeners.forEach((fn) => fn());
};

/** Fuer den Fall, dass das Signal VOR dem Abonnieren kam (Kind-Effekte laufen zuerst). */
export const isSplashReady = (signal: SplashSignal): boolean => gemeldet.has(signal);

export const subscribeSplashReady = (fn: () => void): (() => void) => {
    listeners.add(fn);
    return () => { listeners.delete(fn); };
};
